<template>
    <div id="app">
        <ejs-schedule
            :selectedDate='selectedDate'
            :firstDayOfWeek='firstDayOfWeek'
            :timeScale="timeScale"
            :timeFormat="timeFormat"
            :eventSettings="eventSettings"
            :eventRendered="onEventRendered"
            :timezone="timezone"
            :created="onCreate"
            :actionBegin="onActionBegin"
            :actionComplete="onActionComplete"
            :dataBound="onDataBound"
            :popupOpen="onPopupOpen"
            :quickInfoTemplates="quickInfoTemplates"
            :workHours="workHours"
            :startHour="startHour"
            :endHour="endHour"
            :dragStop="onDragStop"
            :actionFailure="onActionFailure"
            :readonly="readonly"
        >
            <e-views>
                <e-view option="Agenda"></e-view>
                <e-view option="Week"></e-view>
                <e-view option="Month"></e-view>
            </e-views>
        </ejs-schedule>
    </div>
</template>

<script>
import '/node_modules/@syncfusion/ej2-base/styles/material.css';
import '/node_modules/@syncfusion/ej2-buttons/styles/material.css';
import '/node_modules/@syncfusion/ej2-calendars/styles/material.css';
import '/node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
import '/node_modules/@syncfusion/ej2-inputs/styles/material.css';
import '/node_modules/@syncfusion/ej2-navigations/styles/material.css';
import '/node_modules/@syncfusion/ej2-popups/styles/material.css';
import '/node_modules/@syncfusion/ej2-vue-schedule/styles/material.css';
import Vue from 'vue';
import {Internationalization, isNullOrUndefined, closest} from "@syncfusion/ej2-base";
import {DataManager, UrlAdaptor} from '@syncfusion/ej2-data';
import {ButtonPlugin} from "@syncfusion/ej2-vue-buttons";
import {TextBoxPlugin} from "@syncfusion/ej2-vue-inputs";
import {DropDownListPlugin} from "@syncfusion/ej2-vue-dropdowns";
import VueJwtDecode from "vue-jwt-decode";
import {
    SchedulePlugin,
    Day,
    Week,
    Month,
    Agenda,
    DragAndDrop,
} from '@syncfusion/ej2-vue-schedule';

Vue.use(SchedulePlugin);
Vue.use(TextBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(ButtonPlugin);

let dataManager = [];
let patientDataManager = [];
let therapistId = null;
let therapistDbId = null;
let dragStopDate = null;

var headerTemplateVue = Vue.component("headerTemplate", {
    template: `
        <div class="quick-info-header">
        <div class="quick-info-header-content" v-if="data.elementType === 'cell'"
             :style="{'background': '#aaffaa','color':'#FFFFFF'}">
            <div class="quick-info-title">{{ getHeaderTitle(data) }}</div>
            <div class="duration-text">{{ getHeaderDetails(data) }}</div>
        </div>
        <div class="quick-info-header-content" v-else :style="{'background': '#000000','color':'#FFFFFF'}">
            <div class="quick-info-title">{{ getHeaderTitle(data) }}</div>
            <div class="duration-text">{{ getHeaderDetails(data) }}</div>
        </div>
        </div>`,
    data: function () {
        return {
            intl: new Internationalization('ES-es'),
            data: {}
        };
    },
    methods: {
        getHeaderTitle: function (data) {
            return data.elementType === "cell" ? "Nueva cita" : "Detalles";
        },
        getHeaderDetails: function (data) {
            return (
                this.intl.formatDate(data.StartTime, {type: "date", skeleton: "full"}) + " (" +
                this.intl.formatDate(data.StartTime, {skeleton: 'Hm'}) + " - " +
                this.intl.formatDate(data.EndTime, {skeleton: 'Hm'}) + ")"
            );
        }
    }
});

var contentTemplateVue = Vue.component("contentTemplate", {
    template: `
        <v-container>
        <div class="e-cell-content" v-if="data.elementType === 'cell'">
            <div class="content-area">
                <ejs-dropdownlist
                    id='patients'
                    placeholder='Seleccione un paciente'
                    sortOrder='Ascending'
                    :dataSource='patientDataSource'
                    :fields='patientFields'></ejs-dropdownlist>
            </div>
        </div>

        <v-card v-if="data.elementType === 'event'">
            <v-card-subtitle>{{ data.PatientName }}</v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text>
                <v-chip small style="user-select: text; cursor: text" v-for="phone in data.PatientPhones">
                    <v-icon left>mdi-phone</v-icon>
                    {{ phone }}
                </v-chip>
                <v-chip small style="user-select: text; cursor: text">
                    <v-icon left>mdi-email</v-icon>
                    {{ data.PatientEmail }}
                </v-chip>
            </v-card-text>
        </v-card>
        </v-container>`,
    data: () => {
        return {
            patientFields: {
                value: "Id",
                text: "Name"
            },
            patientDataSource: patientDataManager,
            showPatientData: false,
        }
    }
});

var footerTemplateVue = Vue.component("footerTemplate", {
    template: `
        <div class="quick-info-footer">
        <div class="cell-footer" v-if="data.elementType === 'cell'">
            <ejs-button id="add" cssClass="e-flat" content="Agregar cita" :isPrimary="true"
                        v-on:click.native="buttonClickActions"></ejs-button>
            <ejs-button id="toggle-working" cssClass="e-flat" content="Laborable / No laborable"
                        v-on:click.native="buttonClickActions"></ejs-button>
        </div>
        <div class="event-footer" v-if="data.elementType === 'event' && data.Status !== 4 && !isReadonly">
            <ejs-button id="delete" cssClass="e-flat" content="Cancelar cita"
                        v-on:click.native="buttonClickActions"></ejs-button>
        </div>
        <div class="event-footer" v-if="data.elementType === 'event' && (data.Status === 1 || data.Status === 2) && !isReadonly">
            <ejs-button id="confirm" cssClass="e-flat" content="Confirmar"
                        v-on:click.native="buttonClickActions"></ejs-button>
        </div>
        <div class="event-footer" v-if="data.elementType === 'event' && data.Status === 4 && !isReadonly">
            <ejs-button id="hide" cssClass="e-flat" content="Ocultar" :isPrimary="true"
                        v-on:click.native="buttonClickActions"></ejs-button>
        </div>
        </div>`,
    data: function () {
        return {
            data: {}
        };
    },
    methods: {
        buttonClickActions: function (e) {
            const scheduleObj = document.querySelector(".e-schedule").ej2_instances[0];
            const quickPopup = closest(e.target, '.e-quick-popup-wrapper');
            const getSlotData = function () {
                const patientObj = quickPopup.querySelector("#patients").ej2_instances[0];
                let cellDetails = scheduleObj.getCellDetails(scheduleObj.getSelectedElements());
                if (isNullOrUndefined(cellDetails)) {
                    cellDetails = scheduleObj.getCellDetails(scheduleObj.activeCellsData.element);
                }
                let addObj = {};
                addObj.Id = scheduleObj.getEventMaxID();
                addObj.Subject = therapistId;
                addObj.StartTime = new Date(+cellDetails.startTime);
                addObj.EndTime = new Date(+cellDetails.endTime);
                addObj.IsAllDay = false
                addObj.PatientId = patientObj.value;
                addObj.TherapistId = therapistDbId;
                return addObj;
            };
            const getEventData = function () {
                return scheduleObj.activeEventData.event;
            };
            if (e.target.id === "add") {
                const addObj = getSlotData();
                scheduleObj.addEvent(addObj);
            } else if (e.target.id === "save") {
                const editObj = getEventData();
                scheduleObj.saveEvent(editObj, "");
            } else if (e.target.id === "confirm") {
                const editObj = getEventData();
                editObj.IsConfirming = true;
                scheduleObj.saveEvent(editObj, "");
            } else if (e.target.id === "delete") {
                const eventDetails = scheduleObj.activeEventData.event;
                let currentAction = "Delete";
                scheduleObj.deleteEvent(eventDetails, currentAction);
            } else if (e.target.id === "toggle-working") {
                const editObj = getSlotData();
                editObj.ToggleWorking = true;
                scheduleObj.addEvent(editObj);
            } else if (e.target.id === "hide") {
                const eventDetails = scheduleObj.activeEventData.event;
                eventDetails.IsHiding = true;
                scheduleObj.saveEvent(eventDetails, "");
            } else {
                const isCellPopup = quickPopup.firstElementChild.classList.contains("e-cell-popup");
                const eventDetails = isCellPopup ? getSlotData() : scheduleObj.activeEventData.event;
                let currentAction = isCellPopup ? "Add" : "Save";
                if (eventDetails.RecurrenceRule) {
                    currentAction = "EditOccurrence";
                }
                scheduleObj.openEditor(eventDetails, currentAction, true);
            }
            scheduleObj.closeQuickInfoPopup();
        }
    },
    computed: {
        isReadonly() {
            return this.$store.getters.readonly;
        },
    }
});

class CustomAdaptor extends UrlAdaptor {
    processResponse() {
        return super.processResponse.apply(this, arguments);
    }

    beforeSend() {
        const token = localStorage.getItem('token');
        let expiresIn = -1;
        if (token) {
            const decodedToken = VueJwtDecode.decode(token);
            const tokenExpiration = decodedToken.exp;
            expiresIn = (+tokenExpiration - (Math.round(new Date().getTime() / 1000))) * 1000;
        }
        if (expiresIn < 0) {
            window.location.reload(true);
        }
    }
}

export default Vue.extend({
    data() {
        return {
            selectedDate: new Date(),
            timeScale: {enable: true, interval: 60, slotCount: 1},
            firstDayOfWeek: 1,
            eventSettings: {
                dataSource: dataManager,
                fields: {
                    id: 'Id',
                    subject: {name: 'Subject'},
                    startTime: {name: 'StartTime'},
                    endTime: {name: 'EndTime'},
                    therapist: {name: 'TherapistId'},
                    patient: {name: 'PatientId'},
                    patientName: {name: 'PatientName'},
                    patientPhones: {name: 'PatientPhones'},
                    patientEmail: {name: 'PatientEmail'},
                    Description: {name: 'Description'},
                    IsBlock: {name: 'IsBlock'},
                    IsReadonly: {name: 'IsReadonly'},
                    Status: {name: 'Status'},
                }
            },
            timeFormat: 'HH:mm',
            timezone: 'America/Santiago',
            quickInfoTemplates: {
                header: function () {
                    return {template: headerTemplateVue};
                },
                content: function () {
                    return {template: contentTemplateVue};
                },
                footer: function () {
                    return {template: footerTemplateVue};
                }
            },
            workHours: {
                highlight: true,
                start: '08:00',
                end: '08:00'
            },
            startHour: '09:00',
            endHour: '23:00',
            readonly: true,
        }
    },
    provide: {
        schedule: [Day, Week, Month, Agenda, DragAndDrop]
    },
    methods: {
        onEventRendered: function (args) {
            args.element.style.backgroundColor = this.getBackgroundColor(args.data.Status);
        },
        onDragStop: (args) => {
            //console.info("dragStop");
            dragStopDate = args.event.target.dataset.date;
            if (!args.event.target.classList.contains('e-work-hours')) {
                args.cancel = true;
            }
        },
        onActionBegin: function (args) {
            //console.info('onActionBegin');

            const scheduleObj = document.querySelector(".e-schedule").ej2_instances[0];
            if (args.requestType === "eventCreate") {
                if (!args.addedRecords[0].ToggleWorking && args.addedRecords[0].PatientId === null) {
                    alert("Debe seleccionar un paciente para crear una reserva.")
                    args.cancel = true;
                }
                if (!scheduleObj.isSlotAvailable(args.addedRecords[0].StartTime, args.addedRecords[0].EndTime)) {
                    alert("No se puede crear sesiones en paralelo.")
                    args.cancel = true;
                }
            }
            if (args.requestType === "eventChange") {
                if (!args.changedRecords[0].IsHiding) {
                    if (!scheduleObj.isSlotAvailable(args.data.StartTime, args.data.EndTime)) {
                        alert("No se puede crear sesiones en paralelo.");
                        args.cancel = true;
                    }
                }
                if (dragStopDate !== null) {
                    const slotStartTime = args.data.StartTime.getTime();
                    const dragStopCellStartTime = +dragStopDate;
                    if (slotStartTime !== dragStopCellStartTime) {
                        args.cancel = true;
                    }
                }
            }
            dragStopDate = null;
        },
        onActionComplete: function () {
            //console.info('onActionComplete');
        },
        onActionFailure: (args) => {
            const scheduleObj = document.querySelector(".e-schedule").ej2_instances[0];
            let span = document.createElement('span');
            scheduleObj.element.parentNode.insertBefore(span, scheduleObj.element);
            span.style.color = '#FF0000'
            span.innerHTML = 'Server exception: 404 Not found';
            //console.log(args);
        },
        onCreate: function () {
            //console.info('onCreate');
        },
        onPopupOpen: function (args) {
            if (args.data.isAllDay) {
                args.cancel = true;
            }
            if (args.data.IsReadonly) {
                args.cancel = true;
            }
            if ((args.type === 'QuickInfo' || args.type === 'ViewEventInfo') && !args.element.classList.contains('e-template')) {
                args.element.classList.add('e-template');
            }
        },
        async onDataBound() {
            //console.info('dataBound');
            const scheduleObj = document.querySelector(".e-schedule").ej2_instances[0];
            scheduleObj.resetWorkHours();
            var renderedDates = scheduleObj.activeView.getRenderDates();
            for (var i = 0; i < renderedDates.length; i++) {
                var dayIndex = renderedDates[i].getDay();
                if (dayIndex !== 0 && dayIndex !== 6) {
                    scheduleObj.setWorkHours([renderedDates[i]], '09:00', '13:00');
                    scheduleObj.setWorkHours([renderedDates[i]], '14:00', '22:00');
                }
            }

            const token = this.$store.getters.token;
            const response = await fetch(this.$store.getters.apiUrl + "/api/v1/"+ this.$store.getters.therapistId +"/working-slot", {
                method: 'POST',
                headers: new Headers({'Authorization': "Bearer " + token}),
                body: JSON.stringify({
                    StartDate: scheduleObj.activeView.getRenderDates()[0],
                    EndDate: scheduleObj.activeView.getRenderDates()[scheduleObj.activeView.getRenderDates().length - 1]
                })
            });
            const responseData = await response.json();
            if (response.ok) {
                //console.log(responseData);
                responseData.forEach((slot) => {
                    if (slot.isWorking) {
                        scheduleObj.setWorkHours([new Date(slot.date + ' 00:00:00')], slot.startTime, slot.endTime);
                    } else {
                        scheduleObj.resetWorkHours([new Date(slot.date + ' 00:00:00')], slot.startTime, slot.endTime);
                    }
                });
            }
        },
        getBackgroundColor: (index) => {
            const colorsTable = [];
            colorsTable[1] = '#FF8600';
            colorsTable[2] = '#19C73B';
            colorsTable[3] = '#194EC7';
            colorsTable[4] = '#FF0000';

            return colorsTable[index];
        },
        changedTherapist() {
            let token = this.$store.getters.token;
            therapistId = this.$store.getters.userId;
            therapistDbId = this.$store.getters.therapistId;
            //console.log(dataManager.dataSource.url);
            dataManager = new DataManager({
                url: this.$store.getters.apiUrl + "/api/v1/appointment/therapist/" + this.$store.getters.therapistId + "/actions",
                adaptor: new CustomAdaptor(),
                crossDomain: true,
                headers: [{'Authorization': "Bearer " + token}]
            });
            //console.log(dataManager.dataSource.url);
            this.eventSettings.dataSource = dataManager;
            if (document.querySelector(".e-schedule") !== null) {
                const scheduleObj = document.querySelector(".e-schedule").ej2_instances[0];
                scheduleObj.eventSettings = this.eventSettings
            } else {
                if (this.$el.offsetParent !== null) {
                    this.changedTherapist();
                }
            }
        },
    },
    created() {
        let token = this.$store.getters.token;
        therapistId = this.$store.getters.userId;
        therapistDbId = this.$store.getters.therapistId;
        dataManager = new DataManager({
            url: this.$store.getters.apiUrl + "/api/v1/appointment/therapist/" + this.$store.getters.therapistId + "/actions",
            adaptor: new CustomAdaptor(),
            crossDomain: true,
            headers: [{'Authorization': "Bearer " + token}]
        });
        patientDataManager = new DataManager({
            url: this.$store.getters.apiUrl + "/api/v1/patient/simple-list",
            adaptor: new CustomAdaptor(),
            crossDomain: true,
            headers: [{'Authorization': "Bearer " + token}]
        });
        this.eventSettings.dataSource = dataManager;
        this.readonly = this.$store.getters.readonly;
    },
    mounted() {
        this.$root.$on('changedTherapist', () => {this.changedTherapist()});
    },
});
</script>

<style scoped>
>>> .e-week-view .e-appointment {
    width: 100% !important;
}

>>> .e-quick-popup-wrapper .e-event-popup .e-popup-footer {
    display: block;
}

>>> .e-schedule .e-vertical-view .e-work-cells {
    pointer-events: all !important;
    background-color: #f9f9f9;
}

>>> .e-schedule .e-vertical-view .e-work-cells.e-work-hours {
    background-color: white;
    pointer-events: all !important;
}
</style>
